export enum Reducer {
  StateController = 'stateController',
}
